import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import Image from 'gatsby-image';

const Footer = () => {
  const {
    file: {
      childImageSharp: { fluid },
    },
    site: {
      siteMetadata: { author },
    },
  } = useStaticQuery(graphql`
    query {
      file(name: { eq: "logotipo" }) {
        childImageSharp {
          fluid(maxWidth: 570, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      site {
        siteMetadata {
          author
        }
      }
    }
  `);

  return (
    <footer className='py-5 px-7 lg:px-20 z-50 bg-accent mt-auto'>
      <div className='flex flex-wrap gap-y-3 gap-x-3 justify-center md:justify-between items-center'>
        <Link to='/' className='h-auto w-60'>
          <Image fluid={fluid} className='h-full w-auto' />
        </Link>
        <div className='flex items-center justify-self-center gap-3'>
          <a href='https://github.com/josuegalre'>
            <i className='bx bxl-github text-white text-4xl hover:text-black' />
          </a>
          <a href='https://instagram.com/josuegalre'>
            <i className='bx bxl-instagram text-white text-4xl hover:text-black' />
          </a>
          <a href='https://twitter.com/josuegalre'>
            <i className='bx bxl-twitter text-white text-4xl hover:text-black' />
          </a>
        </div>
      </div>
      <p className='text-white mt-5 text-center md:text-left'>
        ©{`${new Date().getFullYear().toString()} ${author}`}. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
